export default "__VITE_ASSET__Djt8eRwf__"